export default __webpack_public_path__ + "static/small-business-economy-accomplishment-3b-44e7a401f8ca6a4ff142358d76626336.webp";